import React, { useState } from 'react';
import { BannerEntity } from '@teko/teko-ecommerce';
import { CustomLink, styled, Image, Overlay } from '@teko/ds-mobile';
import { UnionOutlined } from '@teko/ds-icon';

const Backdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1000;
`;

const WrapperLazyImage = styled.div(({ width }: { width: string | number }) => {
  return `
  width: ${width};
  z-index: 2000;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;}
`;
});

const IconClose = styled.div`
  z-index: 1060;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
`;

export interface PopupPromotionProps {
  banner: BannerEntity;
  isMobile?: boolean;
}

export const PopupPromotion: React.FC<PopupPromotionProps> = ({
  banner,
  isMobile = false,
}: PopupPromotionProps) => {
  const sessionName = `promoBanner${isMobile ? '_mobile' : '_desktop'}`;
  const [isShow, setIsShow] = useState(() => {
    if (typeof sessionStorage !== 'undefined')
      return !sessionStorage.getItem(sessionName);
    return true;
  });
  const handleClose = () => {
    setIsShow(false);
    sessionStorage.setItem(sessionName, banner.image);
  };

  return (
    <Overlay show={isShow} onEscPressed={handleClose}>
      <Backdrop onClick={handleClose} />
      <WrapperLazyImage width={isMobile ? '90%' : '500px'}>
        <IconClose onClick={handleClose}>
          <UnionOutlined size={28} color="white" />
        </IconClose>
        <CustomLink href={banner.targetPath}>
          <Image
            onClick={handleClose}
            src={banner.image}
            alt={banner.campaignName || banner.description || sessionName}
          />
        </CustomLink>
      </WrapperLazyImage>
    </Overlay>
  );
};
